module.exports = __webpack_public_path__ + "media/images/partners/snv-1bfe4354df226db15312587d42d5c951.png";